import { IConsultantContactsState } from '../../types/consultantContacts/consultantContacts';
import { TApplicationState } from '../../types/redux/store';

export const selectIsContactsModalOpen = (state: TApplicationState): IConsultantContactsState['isContactsModalOpen'] =>
  state.consultantContacts.isContactsModalOpen;
